<template>
<transition name="modal-fade">
<div id="image-modal-backdrop" v-show="meta.height">
<div id="image-modal" class=""> 
<div class="container">      
<div class="row">
<div class="col-md-8 align-items-center" id="image-container">
<img :src="meta.url">
</div>
<div class="col-md-4" id="image-meta-container"> 
    <upload-photo :meta="meta" :eid="eid" @cancel="cancel" /></div>
</div>
</div> 
    </div><!--#image-modal -->   
</div><!--#image-modal-backdrop -->  
</transition>          
</template>

<script>
import UploadPhoto from '@/components/upload/UploadPhoto.vue'

export default {
  components: { UploadPhoto },
  props: ['meta', 'eid'],
  methods: {
    cancel() {
      this.$emit('cancel')
    }
  },
  mounted() {
    document.body.classList.add('modal-open')
  },
  beforeDestroy() {
    document.body.classList.remove('modal-open')
  }
}
</script>

<style scoped lang="scss">
img {
  max-width: 100%;
  max-height: calc(100vh);
}

#image-modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.66);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1200;
  height: 100vh;
}
#image-modal {
  overflow-x: hidden;
  overflow-y: auto;
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
}

#image-container {
  padding: 0;
  background-color: black;
}

#image-meta-container .modal-header {
  border-bottom: none;
  margin-right: -15px;
}

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>
